// Entity
import { TaskDetailsBuilder } from "../../legacyPlanner/task/TaskDetailsBuilder";
/** Class to handle serialization/deserialization for task details data */ export class TaskDetailsSerializationHandler {
    /** serialize to IGraphTaskDetailsResource */ toSerializable(key, value) {
        return value.toGraphSerializable();
    }
    /** build ITaskDetails from IGraphTaskDetailsResource */ fromSerializable(key, serializableValue) {
        return new TaskDetailsBuilder().fromGraphResource(serializableValue).build();
    }
}
